export const commonIconProps12 = {
  size: 12,
  color: "#030712",
  className: "size-[12px]",
};

export const commonIconProps13 = {
  size: 13,
  color: "#09090B",
  className: "size-[13px]",
};

export const commonIconProps14 = {
  size: 14,
  color: "#030712",
  className: "size-[14px]",
};

export const commonIconProps16 = {
  size: 16,
  color: "#030712",
  className: "size-[16px]",
};

export const commonIconProps20 = {
  size: 20,
  color: "#030712",
  className: "size-[20px]",
};

export const commonIconProps24 = {
  size: 24,
  color: "#030712",
  className: "size-[24px]",
};

export const commonIconProps32 = {
  size: 32,
  color: "#030712",
  className: "size-[32px]",
};
